var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.isMobile ? 'signature-box-mobile' : 'signature-box']},[_c('vue-signature-pad',{ref:"signaturePad",attrs:{"height":_vm.isMobile ? '110px' : '65px',"options":{
      onBegin: () => {
        _vm.$refs.signaturePad.resizeCanvas()
      },
      onEnd: _vm.saveSignature,
    }}}),_c('v-divider',{staticClass:"mx-2"}),_c('div',{staticClass:"ma-1"},[_c('v-btn',{staticClass:"font-weight-bold",attrs:{"text":"","small":"","color":"success"},on:{"click":_vm.saveSignature}},[_vm._v(_vm._s(_vm.signed ? _vm.$t('Update') : _vm.$t('Save')))]),_c('v-btn',{attrs:{"text":"","small":"","color":"black"},on:{"click":function($event){return _vm.$refs.signaturePad.clearSignature()}}},[_vm._v(_vm._s(_vm.$t('Clear')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }